import React from 'react'
import { Link, useParams } from 'react-router-dom'
import EditTaxPayerForm from './EditTaxPayerForm'

const EditTaxPayer = () => {
  const { id } = useParams()

  return (
    <section className="space-y-4">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-xl font-semibold text-slate-800">
              Edit Taxpayer
            </h1>
            <p className="text-sm text-slate-500">
              Update taxpayer record #{id}
            </p>
          </div>

          <Link
            to="/taxpayers"
            className="inline-flex items-center justify-center rounded-xl border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
          >
            Back to List
          </Link>
        </div>
      </div>

      <EditTaxPayerForm taxpayerId={id} />
    </section>
  )
}

export default EditTaxPayer